import { useSelector } from "react-redux";
import "./AdCompany.scss";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import CircularButton, {
  CustomLoadingButton,
} from "../../../components/ui/CustomButton.jsx";
import { customSelectStyles_dark, customSelectStyles_light, muiSelectStyles_dark, muiSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { showToast } from "../../../toastService.js";
import app from "../../../utils/firebase";
import newRequest from "../../../utils/newRequest.js";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Select as MuiSelect,
  MenuItem,
} from "@mui/material";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { motion } from "framer-motion";
import numeral from "numeral";
import moment from "moment";
import { useEffect, useState } from "react";
import Select from "react-select";
import { GridLoader, ScaleLoader } from "react-spinners";
import { Segmented } from 'antd';
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { MdAdd, MdArrowBackIos, MdClose, MdDelete, MdEdit, MdSave } from "react-icons/md";
import { getCssValue, handleOpenMap, logData } from "../../../utils/genericFunctions.js";
import UploadDialog from "../../../components/uploadDialog/UploadDialog.jsx";
import AdDocumentSign from "../adDocumentSign/AdDocumentSign.jsx";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch.jsx";
import { IoDocumentTextSharp, IoLocationSharp } from "react-icons/io5";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports.jsx";
import { GrSync } from "react-icons/gr";
import GooglePlacesSelect from "../../../components/googlePlacesSelect/GooglePlacesSelect.jsx";
import { RiMapPin5Fill } from "react-icons/ri";


const AdCompany = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const showBack = location.state?.showBack || "N";
  const { currentTheme } = useSelector((state) => state.theme);
  const { currentUser } = useSelector((state) => state.user);
  const [uploadTarget, setUploadTarget] = useState("firebase");
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isProcessingTitle, setIsProcessingTitle] = useState(t('pleaseWait'));
  const [bankAccounts, setBankAccounts] = useState([]);
  const [currencyAction, setCurrencyAction] = useState("");
  const [isCodeDialogOpened, setIsCodeDialogOpened] = useState(false);
  const [selectedAdminToAdd, setSelectedAdminToAdd] = useState(null);
  const [img, setImg] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploadDialogOpen, setIsUploadDialogOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [orgUnits, setOrgUnits] = useState([]);
  const [reportGroupArray, setReportKeysArray] = useState(["org-stats"]);

  const [reportVersions, setReportVersions] = useState([]);
  const [searchTermRepVer, setSearchTermRepVer] = useState("");

  const [isNumGenDialogOpened, setIsNumGenDialogOpened] = useState(false);
  const [selectedOrgUnit, setSelectedOrgUnit] = useState({});
  const [orgStats, setOrgStats] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    action_invoked: "",
  });
  const [alignValue, setAlignValue] = useState('more');
  const [orgRecordData, setOrgRecordData] = useState({});
  const [orgDocId, setOrgDocId] = useState("");
  const [orgCode, setOrgCode] = useState("");
  const [orgName, setOrgName] = useState("");
  const [orgType, setOrgType] = useState("");
  const [orgWebsite, setOrgWebsite] = useState("");
  const [orgAddress1, setOrgAddress1] = useState("");
  const [orgAddress2, setOrgAddress2] = useState("");
  const [orgEmail, setOrgEmail] = useState("");
  const [orgPhone, setOrgPhone] = useState("");
  const [orgLogoUrl, setOrgLogoUrl] = useState("");
  const [orgBaseCur, setOrgBaseCur] = useState("");
  const [orgDocsSignature, setOrgDocsSignature] = useState(null);
  const [orgTaxPin, setOrgTaxPin] = useState("");
  const [orgLicenseNo, setOrgLicenseNo] = useState("");
  const [orgStatus, setOrgStatus] = useState("");
  const [orgAdmins, setOrgAdmins] = useState([]);
  const [numberGens, setNumberGens] = useState([]);
  const [selectedNumberGen, setSelectedNumberGen] = useState({});
  const [dmvicFlag, setDmvicFlag] = useState([]);

  const [orgMission, setOrgMission] = useState("");
  const [orgVision, setOrgVision] = useState("");
  const [orgAboutUs, setOrgAboutUs] = useState("");
  const [orgPlan, setOrgPlan] = useState("");

  const [orgActivateKyc, setOrgActivateKyc] = useState("Y");
  const [orgActivateAml, setOrgActivateAml] = useState("Y");

  const [orgVatExempt, setOrgVatExempt] = useState("N");
  const [orgWithholdingExempt, setOrgWithholdingExempt] = useState("N");

  const [placesDialogOpen, setPlacesDialogOpen] = useState(false);
  const [selectedPlace, setSelectedPlace] = useState(null);

  const [orgDmvicSettings, setOrgDmvicSettings] = useState({
    token_api_username: "",
    token_api_password: "",
    token_cert_password: "",
    token_client_id: "",
    token_company_id: "",
    token_dmvic_flag: "Test",
    token_value: "",
    token_issued: null,
    token_expiry: null,
    portal_username: "",
    portal_password: ""
  });

  const [orgBimaEndpoints, setOrgBimaEndpoints] = useState([]);
  const [selectedOrgEndpoint, setSelectedOrgEndpoint] = useState(null);
  const [orgBimaCategory, setOrgBimaCategory] = useState([]);

  const [endpointTypes, setEndpointTypes] = useState([]);
  const [selectedEndpoint, setSelectedEndpoint] = useState(null);
  const [endpointAddress, setEndpointAddress] = useState(null);

  const [entityCategories, setEntityCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedOrgCategory, setSelectedOrgCategory] = useState(null);

  const [openAddUnit, setOpenAddUnit] = useState(false);
  const [unitCode, setUnitCode] = useState("");
  const [unitName, setUnitName] = useState("");
  const [unitType, setUnitType] = useState(null);
  const [unitAddress1, setUnitAddress1] = useState("");
  const [unitAddress2, setUnitAddress2] = useState("");
  const [unitEmail, setUnitEmail] = useState("");
  const [unitPhone, setUnitPhone] = useState("");
  const [unitStatus, setUnitStatus] = useState(null);
  const [unitTypeOptions, setUnitTypeOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [unitBankAc, setUnitBankAc] = useState(null);
  const [unitLatitude, setUnitLatitude] = useState(null);
  const [unitLongitude, setUnitLongitude] = useState(null);
  const [unitPlaceName, setUnitPlaceName] = useState(null);
  const [signOptions, setSignOptions] = useState([]);


  const fetchBizUnitStatus = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Biz Unit Status" });
      const options = res.data?.map((val) => ({
        value: val?.sys_code,
        label: val?.sys_name,
      }));
      setStatusOptions(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchBankAccounts = async () => {
    try {
      const res = await newRequest.get("/glBankAc/findAll");

      // Filter the bank accounts based on the specified conditions
      const filteredAccounts = res.data?.filter((bank) =>
        bank?.ac_status === "Active" &&
        bank?.ac_visible === "Y" &&
        bank?.ac_receipt === "Y"
      );

      // Map the filtered accounts to the desired options format
      const options = filteredAccounts.map((bank) => ({
        bank_code: bank?.bank_code_xx,
        branch_code: bank?.bank_branch_code_xx,
        value: bank?.ac_no,
        label: bank?.ac_name,
      }));

      setBankAccounts(options);

    } catch (error) {
      console.error("Error fetching bank accounts :", error);
    }
  };


  const fetchBizUnitType = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Biz Unit Type", });

      const options = res.data?.map((val) => ({
        value: val?.sys_code,
        label: val?.sys_name,
      }));

      setUnitTypeOptions(options);
    } catch (error) {
      console.error("Error fetching type types:", error);
    }
  };

  // documents
  const [newDocType, setNewDocType] = useState(null);
  const [documentOptions, setDocumentOptions] = useState([]);
  const fetchDocuments = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Documents" });
      const options = res.data?.map((row) => ({
        value: row?.sys_code,
        label: row?.sys_name,
      }));

      setDocumentOptions(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const popoverOpen = Boolean(anchorEl);
  const id = popoverOpen ? 'simple-popover' : undefined;


  const handlePopoverClose = () => {
    setNewDocType(null);
    setAnchorEl(null);
  };


  const fetchOrganization = async () => {
    try {
      setIsLoading(true);
      const res = await newRequest.get("/org/find");
      if (res.data) {
        setOrgRecordData(res.data);
        setOrgDocId(res.data?._id);
        setOrgCode(res.data?.org_code);
        setOrgName(res.data?.org_name);
        setOrgType(res.data?.org_type);
        setOrgWebsite(res.data?.org_website);
        setOrgAddress1(res.data?.org_address1);
        setOrgAddress2(res.data?.org_address2);
        setOrgEmail(res.data?.org_email);
        setOrgPhone(res.data?.org_phone);
        setOrgLogoUrl(res.data?.org_logo_url);
        setOrgBaseCur(res.data?.org_base_cur);
        setOrgTaxPin(res.data?.org_tax_pin);
        setOrgLicenseNo(res.data?.org_license_no);
        setOrgStatus(res.data?.org_status);
        setReportVersions(res.data?.org_report_versions);
        setOrgMission(res.data?.org_mission);
        setOrgVision(res.data?.org_vision);
        setOrgAboutUs(res.data?.org_about_us);
        setOrgPlan(res.data?.org_plan);
        setOrgActivateKyc(res.data?.org_activate_kyc);
        setOrgActivateAml(res.data?.org_activate_aml);

        setOrgVatExempt(res.data?.org_vat_exempt);
        setOrgWithholdingExempt(res.data?.org_withholding_exempt);

        setOrgDmvicSettings(res.data?.org_dmvic_settings);

        setOrgBimaEndpoints(res.data?.org_bima_endpoints || []);
        setOrgBimaCategory(res.data?.org_bima_category || []);

        // logData("res.data?.org_bima_category", res.data?.org_bima_category);

        fetchOrganizationAdmins(res.data?._id);

        setOrgDocsSignature({
          value: res.data?.org_docs_signature,
          label: res.data?.org_docs_signature,
        });

        // set signature options
        const options = ["Shared", "Approver", "Creator"]?.map((val) => ({
          value: val,
          label: val,
        }));
        setSignOptions(options);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchOrganizationStats = async () => {
    try {
      const res = await newRequest.get("/org/stats");
      setOrgStats(res.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchOrganizationAdmins = async (org_docid) => {
    try {
      const res = await newRequest.post("/org/getAdmins", { org_docid: org_docid });
      setOrgAdmins(res.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const fetchOrganizationUnits = async () => {
    try {
      const res = await newRequest.post("/orgUnit/findAll", { unit_status: "" });
      setOrgUnits(res.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const [currentOrgUnitPage, setCurrentOrgUnitPage] = useState(0);
  const handleOrgUnitsPageChange = (event, newPage) => {
    setCurrentOrgUnitPage(newPage);
  };

  const slicedOrgUnits = orgUnits.slice(
    currentOrgUnitPage * rowsPerPage,
    currentOrgUnitPage * rowsPerPage + rowsPerPage
  );

  const handleOrgUnitsRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 5));
    setCurrentOrgUnitPage(0);
  };


  // number generation
  const [currentNumGenPage, setCurrentNumGenPage] = useState(0);
  const handleNumGensPageChange = (event, newPage) => {
    setCurrentNumGenPage(newPage);
  };

  const slicedNumGens = numberGens.slice(
    currentNumGenPage * rowsPerPage,
    currentNumGenPage * rowsPerPage + rowsPerPage
  );

  const handleNumGensRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 5));
    setCurrentNumGenPage(0);
  };

  const fetchNumberGenerations = async () => {
    try {
      const res = await newRequest.post("/orgNumgen/findAll", { gen_org_code: currentUser.usr_org_code });

      setNumberGens(res.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchDmvicFlag = () => {
    try {
      const options = ["Test", "Prod"].map((val) => ({
        value: val,
        label: val,
      }));
      setDmvicFlag(options);
    } catch (error) {
      console.error("Error fetching dmvic flag :", error);
    }
  };

  const fetchEndpointTypes = () => {
    try {
      const options = ["Entity", "Policy", "Risk Note", "Claim", "Receipt", "Payment"].map((val) => ({
        value: val,
        label: val,
      }));
      setEndpointTypes(options);
    } catch (error) {
      console.error("Error fetching dmvic flag :", error);
    }
  };

  const fetchEntityCatg = async () => {
    try {
      const res = await newRequest.get("/allEntityCatg/findAll");
      const options = res.data?.map((entityCatg) => ({
        value: entityCatg?.aent_code,
        label: entityCatg?.aent_name,
      }));
      setEntityCategories(options);
    } catch (error) {
      console.error("Error fetching entity category:", error);
    }
  };

  useEffect(() => {
    fetchOrganization();
    fetchNumberGenerations();
    fetchOrganizationUnits();
    fetchUsers();
    fetchOrganizationStats();
    fetchBizUnitStatus();
    fetchBizUnitType();
    fetchDocuments();
    fetchBankAccounts();
    fetchDmvicFlag();
    fetchEndpointTypes();
    fetchEntityCatg();
  }, []);

  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "removeAdmin") {
        await newRequest.post(
          "/org/delAdmin",
          {
            org_docid: orgDocId,
            org_admin_docid: objectToAction.object_id,
            userCode: currentUser.usr_id,
          }
        );
        fetchOrganizationAdmins(orgDocId);
      } else if (confirmDialogAction === "deleteNumGen") {
        await newRequest.delete(`/orgNumgen/del/${objectToAction.object_id}`);
        fetchNumberGenerations();
        showToast("Deleted!", "success");
      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  const handleOrgUnitsChange = (e, rowId) => {
    try {
      const { name, value } = e.target;
      const updatedData = [...orgUnits];
      const rowIndex = updatedData.findIndex(item => item._id === rowId);

      if (rowIndex === -1) {
        throw new Error('Row not found');
      }
      updatedData[rowIndex][name] = value;
      updatedData[rowIndex]["changed_xx"] = "Y";

      setOrgUnits(updatedData);
    } catch (error) {
      console.log(error);
    }
  };


  const handleNumGens = (value, rowId, field) => {
    setNumberGens((prevData) =>
      prevData.map((item) =>
        item._id === rowId
          ? { ...item, [field]: value, changed_xx: "Y" }
          : item
      )
    );
  };

  const saveRecord = async (e) => {
    // e.preventDefault();
    try {
      setIsProcessing(true);

      await newRequest.put(
        `/org/upd/${orgDocId}`,
        {
          org_website: orgWebsite,
          org_address1: orgAddress1,
          org_address2: orgAddress2,
          org_email: orgEmail,
          org_phone: orgPhone,
          org_tax_pin: orgTaxPin,
          org_license_no: orgLicenseNo,
          org_mission: orgMission,
          org_vision: orgVision,
          org_about_us: orgAboutUs,
          org_activate_kyc: orgActivateKyc,
          org_activate_aml: orgActivateAml,
          org_dmvic_settings: orgDmvicSettings,
          org_docs_signature: orgDocsSignature?.value,
          org_vat_exempt: orgVatExempt || "N",
          org_withholding_exempt: orgWithholdingExempt || "N",
          org_bima_endpoints: orgBimaEndpoints || [],
          org_bima_category: orgBimaCategory || []
        }
      );

      if (img) {
        if (uploadTarget === "firebase") {
          await uploadToFirebase(img, "logos");
        } else {
          await uploadToBackend(img, "logos");
        }
      }

      const changedNumgen = numberGens?.filter((obj) => obj.changed_xx === "Y");
      for (let i = 0; i < changedNumgen.length; i++) {
        await newRequest.put(
          `/orgNumgen/upd/${changedNumgen[i]._id}`,
          {
            gen_auto: changedNumgen[i].gen_auto,
            gen_current_no: changedNumgen[i].gen_current_no,
            gen_prefix: changedNumgen[i].gen_prefix,
            gen_surfix: changedNumgen[i].gen_surfix,
            gen_entity_type: changedNumgen[i].gen_entity_type,
          }
        );
      }
      showToast("Updated!", "success");
    } catch (err) {
      console.log(err);
    } finally {
      setIsProcessing(false);
    }
  };

  const uploadToFirebase = async (file, fileFolder) => {
    setIsUploadDialogOpen(true);
    const storage = getStorage(app);
    const fileName = new Date().getTime() + file.name;
    const fileExtension = file.name.split(".").pop(); // Get file extension
    const fileType = file.type; // Get file type
    const fileSizeKB = file.size / 1024; // Get file size in KB
    const storageRef = ref(
      storage,
      `qc_${currentUser.usr_org_code}/${fileFolder}/${fileName}`
    );
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setUploadProgress(Math.round(progress));
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
          default:
            break;
        }
      },
      (error) => {
        setIsUploadDialogOpen(false);
        console.log(error);
      },
      async () => {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);

        // update org logo
        await newRequest.put(`/org/upd/${orgDocId}`, { org_logo_url: downloadURL });
        // console.log(`Update Logo response ${res.data}`)
        setOrgLogoUrl(downloadURL);

        // download logo as a file and store in assets folder
        await newRequest.post(
          `/org/logo`,
          {
            logo_url: downloadURL,
            org_code: currentUser.usr_org_code,
          }
        );
        // console.log(`Reset Logo response ${logo.data}`)
        setImg("");
        setIsUploadDialogOpen(false);
      }
    );
  };

  // ---------- Upload to backend (multipart/form-data) ----------
  const uploadToBackend = async (file, fileFolder) => {
    const formData = new FormData();
    // metadata the backend can use to organize + save DB record
    formData.append("orgCode", currentUser.usr_org_code);
    formData.append("folder", fileFolder);
    formData.append("documentType", "Logo");
    formData.append("documentNo", currentUser.usr_org_code);
    formData.append("documentId", currentUser.usr_org_code);
    formData.append("userCode", currentUser.usr_id);

    // IMPORTANT append file LAST
    formData.append("file", file);

    // optional: progress bar (axios supports onUploadProgress)
    const res = await newRequest.post("/uploadFiles/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (evt) => {
        if (!evt.total) return;
        const progress = (evt.loaded / evt.total) * 100;
        setUploadProgress(Math.round(progress));
      },
    });

    // logData("org", res.data);

    await newRequest.put(`/org/upd/${orgDocId}`, { org_logo_url: res.data?.file?.fl_path });
    setOrgLogoUrl(res.data?.file?.fl_path);

    return res.data;
  };

  const fetchUsers = async () => {
    try {
      const res = await newRequest.post("/adUser/findAll");
      const options = res.data?.map((user) => ({
        value: user._id,
        label: user.usr_full_name,
      }));

      setUsers(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const handleAddAdmin = async () => {
    try {
      const res = await newRequest.post("/org/addAdmin", { user_docid: selectedAdminToAdd.value });
      if (res.data === "exists") {
        showToast(
          `User ${selectedAdminToAdd.label} is already an admin`,
          "error"
        );
      } else {
        showToast(`User ${selectedAdminToAdd.label} added as admin`, "success");
      }
      setSelectedAdminToAdd({ value: "", label: "" });
      fetchOrganizationAdmins(orgDocId);
    } catch (error) {
      console.log(error);
    }
  };


  const handleBizUnitAction = async () => {
    try {

      // Check for both insert and update

      if (!unitName) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter name!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!unitType) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please select type!`);
        setIsNotifyDialogOpen(true);
        return;
      }
      // console.log(`currencyAction is ${currencyAction}`)
      if (currencyAction === "addUnit") {
        if (!unitCode) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Please enter unique code!`);
          setIsNotifyDialogOpen(true);
          return;
        }
        const res = await newRequest.post(
          "/orgUnit/add",
          {
            unit_code: unitCode,
            unit_name: unitName,
            unit_type: unitType?.value,
            unit_address1: unitAddress1,
            unit_address2: unitAddress2,
            unit_email: unitEmail,
            unit_phone: unitPhone,
            unit_status: unitStatus?.value,
            unit_bank_ac: unitBankAc?.value,
            unit_latitude: unitLatitude,
            unit_longitude: unitLongitude,
            unit_place_name: unitPlaceName,
          }
        );
        if (res.data === "exists") {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`<strong>${unitCode}</strong> is not unique. Choose another code!`);
          setIsNotifyDialogOpen(true);
          return;
        } else {
          setSelectedOrgUnit(null);
          setCurrencyAction("none");
          setUnitCode("");
          setUnitAddress1("");
          setUnitEmail("");
          setUnitPhone("");
          setUnitStatus(null);
          setUnitBankAc(null);
          setUnitLatitude(null);
          setUnitLongitude(null);
          setUnitPlaceName(null);

          fetchOrganizationUnits();
          setOpenAddUnit(false);
          showToast(`${unitType?.label} ${unitName} added!`, "success");
          setUnitName("");
          setUnitType(null);
        }
      } else if (currencyAction === "editUnit") {
        await newRequest.put(
          `/orgUnit/upd/${selectedOrgUnit._id}`,
          {
            unit_name: unitName,
            unit_type: unitType?.value,
            unit_address1: unitAddress1,
            unit_address2: unitAddress2,
            unit_email: unitEmail,
            unit_phone: unitPhone,
            unit_status: unitStatus?.value,
            unit_bank_ac: unitBankAc?.value,
            unit_latitude: unitLatitude,
            unit_longitude: unitLongitude,
            unit_place_name: unitPlaceName,
          }
        );
        setSelectedOrgUnit(null);
        setCurrencyAction("none");
        setUnitCode("");
        setUnitAddress1("");
        setUnitEmail("");
        setUnitPhone("");
        setUnitStatus(null);
        fetchOrganizationUnits();
        setOpenAddUnit(false);
        showToast(`${unitType?.label} ${unitName} updated!`, "success");
        setUnitName("");
        setUnitType(null);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const updateDmvicField = (field, value) => {
    setOrgDmvicSettings(prev => ({ ...prev, [field]: value }));
  };


  const handleNumGenAction = async () => {
    try {

      if (!newDocType?.value) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter type!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      const res = await newRequest.post(
        "/orgNumgen/add",
        {
          gen_type: newDocType?.value,
          gen_auto: "Y",
          gen_current_no: 1000,
          gen_prefix: "",
          gen_surfix: ""
        }
      );

      if (res.data === "exists") {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`<strong>${newDocType?.value}</strong> already exists!`);
        setIsNotifyDialogOpen(true);
      } else if (res.data === "success") {
        fetchNumberGenerations();
        handlePopoverClose();
        showToast(`${newDocType?.value} Added!`, "success");
        setNewDocType(null);
      } else {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(res.data);
        setIsNotifyDialogOpen(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handlePlaceSelect = (place) => {
    try {
      if (!place) {
        setSelectedPlace(null);
        setUnitLatitude(null);
        setUnitLongitude(null);
        setUnitPlaceName(null);
        // console.log(`no place selected`);
      } else {
        // console.log(`Selected Place  ${JSON.stringify(place, null, 2)}`);
        setSelectedPlace(place);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleReportVersionChange = async (e, rowId) => {
    try {
      const { name, value } = e.target;
      const updatedData = [...reportVersions];
      const rowIndex = updatedData.findIndex(item => item._id === rowId);

      if (rowIndex === -1) {
        console.log('Row not found');
      }
      await newRequest.post("/org/ver", { report_docid: rowId, version: value });
      // console.log(res.data)
      updatedData[rowIndex][name] = value;
      setReportVersions(updatedData);
    } catch (error) {
      console.log(error);
    }
  };


  const filteredRepVerData = reportVersions.filter(
    (item) =>
      item.report_title?.toLowerCase().includes(searchTermRepVer?.toLowerCase()) ||
      item.report_desc?.toLowerCase().includes(searchTermRepVer?.toLowerCase())
  );


  return (
    <div className="ad-company">
      {isLoading ? (
        <div className="no-content"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="ad-company-main-wrapper">
          <div className="company-center-wrapper">
            <div className="center-details">
              <div className="center-navbar">
                <h1 className="page-title">{orgName?.toUpperCase()}</h1>
                <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center" }}>
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    variant="tint"
                    color="#2563EB"
                    tooltip="Run reports for this document"
                    endIcon={<IoDocumentTextSharp />}
                    onClick={() => {
                      try {
                        navigate("/reports/all-generic");
                      } catch (error) {
                        console.log(error);
                      }
                    }}>
                    {t('reports')}
                  </CustomLoadingButton>
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType="both"
                    variant="tint"
                    color="#00D37F"
                    tooltip="Save changes"
                    endIcon={<MdSave />}
                    onClick={saveRecord}
                  >
                    {t('save')}
                  </CustomLoadingButton>
                </div>
              </div>
              <ExpandableComponent
                title={t('basicInformation').toUpperCase()}
                subtitle={`${orgCode} : ${orgRecordData?.org_country} : ${orgRecordData?.org_plan}`}
                defaultExpanded={true}
              >
                <div className="org-details-wrapper">
                  <div className="org-details-left">
                    <div className="input-item-with-label">
                      <label
                        htmlFor="org_name"
                        style={{
                          width: "100px",
                        }}
                      >
                        {t('name').toUpperCase()}
                      </label>
                      <input
                        id="org_name"
                        name="org_name"
                        type="text"
                        placeholder={t('name').toUpperCase()}
                        value={orgName}
                        onChange={(e) => setOrgName(e.target.value)}
                        className="form-input-item"
                        style={{ width: "350px" }}
                        disabled={!["superadmin"].includes(currentUser.user_type_xx)}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label
                        htmlFor="org_email"
                        style={{
                          width: "100px",
                        }}
                      >
                        {t('email').toUpperCase()}
                      </label>
                      <input
                        id="org_email"
                        name="org_email"
                        type="text"
                        placeholder={t('email').toUpperCase()}
                        value={orgEmail}
                        onChange={(e) => setOrgEmail(e.target.value)}
                        className="form-input-item"
                        style={{ width: "350px" }}
                        disabled={!["superadmin"].includes(currentUser.user_type_xx)}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label
                        htmlFor="org_phone"
                        style={{
                          width: "100px",
                        }}
                      >
                        {t('phoneNo').toUpperCase()}
                      </label>
                      <input
                        id="org_phone"
                        name="org_phone"
                        type="text"
                        placeholder={t('phoneNo').toUpperCase()}
                        value={orgPhone}
                        onChange={(e) => setOrgPhone(e.target.value)}
                        className="form-input-item"
                        style={{ width: "350px" }}
                        disabled={!["superadmin"].includes(currentUser.user_type_xx)}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label
                        htmlFor="org_website"
                        style={{
                          width: "100px",
                        }}
                      >
                        {t('website').toUpperCase()}
                      </label>
                      <input
                        id="org_website"
                        name="org_website"
                        type="text"
                        placeholder={t('website').toUpperCase()}
                        value={orgWebsite}
                        onChange={(e) => setOrgWebsite(e.target.value)}
                        className="form-input-item"
                        style={{ width: "350px" }}
                        disabled={!["superadmin"].includes(currentUser.user_type_xx)}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label
                        htmlFor="org_address1"
                        style={{
                          width: "100px",
                          alignSelf: "flex-start",
                        }}
                      >
                        {t('address').toUpperCase()}
                      </label>
                      <textarea
                        id="org_address1"
                        name="org_address1"
                        type="text"
                        placeholder={t('address').toUpperCase()}
                        value={orgAddress1}
                        rows={4}
                        onChange={(e) => setOrgAddress1(e.target.value)}
                        className="form-input-item"
                        style={{ width: "350px" }}
                        disabled={!["superadmin"].includes(currentUser.user_type_xx)}
                      />
                    </div>

                    {/* <div className="input-item-with-label">
                    <label
                      htmlFor="org_address2"
                      style={{
                        width: "100px",
                        alignSelf: "flex-start",
                      }}
                    >
                      {t('address').toUpperCase()}
                    </label>
                    <textarea
                      id="org_address2"
                      name="org_address2"
                      type="text"
                      placeholder={t('address').toUpperCase()}
                      value={orgAddress2}
                      rows={2}
                      onChange={(e) => setOrgAddress2(e.target.value)}
                      className="form-input-item"
                      style={{ width: "350px" }}
                      disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                    />
                  </div> */}
                  </div>
                  <div className="org-details-right">
                    <div className="logo">
                      {!img && (
                        <img
                          src={orgLogoUrl || "/img/noimage.png"}
                          alt=""
                          className="img"
                        />
                      )}
                      {img && (
                        <img
                          src={
                            img ? URL.createObjectURL(img) : "/img/noimage.png"
                          }
                          alt=""
                          className="img"
                        />
                      )}
                      <input
                        type="file"
                        id="file"
                        style={{ display: "none" }}
                        // accept="image/*"
                        accept=".png,image/png"
                        onChange={(e) => {
                          try {
                            const file = e.target.files[0];
                            if (file && file.type.includes('image/png')) {
                              setImg(file);
                            } else {
                              // Handle case where file doesn't match expected type
                              console.log('Please select a .png file.');
                            }
                          } catch (error) {
                            console.log(error)
                          }
                        }}
                      />
                      {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                        <label htmlFor="file">
                          <div className="item" style={{ cursor: "pointer" }}>
                            <h1 className="sub-title">{t('select').toUpperCase()} (.png Only)</h1>
                          </div>
                        </label>}
                    </div>
                    <div className="inputs">
                      <div className="input-item-with-label"
                        style={{ justifyContent: "flex-end" }}>
                        <label
                          htmlFor="org_license_no"
                          style={{
                            width: "100px",
                          }}
                        >
                          {t('licenseNo').toUpperCase()}
                        </label>
                        <input
                          id="org_license_no"
                          name="org_license_no"
                          type="text"
                          placeholder={t('licenseNo').toUpperCase()}
                          value={orgLicenseNo}
                          onChange={(e) => setOrgLicenseNo(e.target.value)}
                          className="form-input-item"
                          style={{ width: "180px" }}
                          disabled={!["superadmin"].includes(currentUser.user_type_xx)}
                        />
                      </div>
                      <div
                        className="input-item-with-label"
                        style={{ justifyContent: "flex-end" }}
                      >
                        <label
                          htmlFor="org_tax_pin"
                          style={{
                            width: "max-content",
                          }}
                        >
                          {t('taxPin').toUpperCase()}
                        </label>
                        <input
                          id="org_tax_pin"
                          name="org_tax_pin"
                          type="text"
                          placeholder={t('taxPin').toUpperCase()}
                          value={orgTaxPin}
                          onChange={(e) => setOrgTaxPin(e.target.value)}
                          className="form-input-item"
                          style={{ width: "180px" }}
                          disabled={!["superadmin"].includes(currentUser.user_type_xx)}
                        />
                      </div>
                      <div
                        className="input-item-with-label"
                        style={{ justifyContent: "flex-end" }}
                      >
                        <label
                          htmlFor="org_base_cur"
                          style={{
                            width: "max-content",
                          }}
                        >
                          {t('currency').toUpperCase()}
                        </label>
                        <input
                          id="org_base_cur"
                          name="org_base_cur"
                          type="text"
                          placeholder={t('currency').toUpperCase()}
                          value={orgBaseCur}
                          onChange={(e) => setOrgBaseCur(e.target.value)}
                          className="form-input-item"
                          style={{ width: "180px" }}
                          disabled
                        />
                      </div>
                      <div
                        className="input-item-with-label"
                        style={{ justifyContent: "flex-end" }}
                      >
                        <label
                          htmlFor="org_docs_signature"
                          style={{
                            width: "max-content",
                          }}
                        >
                          {t('signToUse').toUpperCase()}
                        </label>
                        <Select
                          id="org_docs_signature"
                          name="org_docs_signature"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="180px"
                          value={orgDocsSignature}
                          onChange={(selectedOption) => setOrgDocsSignature(selectedOption)}
                          options={signOptions}
                          placeholder={t('select')}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-grid-auto">
                  <div className="input-item-with-label">
                    <label
                      htmlFor="orgActivateKyc"
                      style={{
                        width: "90px",
                        alignSelf: "flex-start",
                      }}
                    />
                    <ToggleSwitch
                      value={orgActivateKyc}
                      onChange={(newValue) => setOrgActivateKyc(newValue)}
                      label={t('activateKycChecks').toUpperCase()}
                      labelPosition="end"
                      labelWidth="max-content"
                      border="N"
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="orgVatExempt"
                      style={{
                        width: "90px",
                        alignSelf: "flex-start",
                      }}
                    />
                    <ToggleSwitch
                      value={orgVatExempt}
                      onChange={(newValue) => setOrgVatExempt(newValue)}
                      label={t('commVatExcempt').toUpperCase()}
                      labelPosition="end"
                      labelWidth="max-content"
                      border="N"
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="orgActivateAml"
                      style={{
                        width: "90px",
                        alignSelf: "flex-start",
                      }}
                    />
                    <ToggleSwitch
                      value={orgActivateAml}
                      onChange={(newValue) => setOrgActivateAml(newValue)}
                      label={t('activateAmlChecks').toUpperCase()}
                      labelPosition="end"
                      labelWidth="max-content"
                      border="N"
                    />
                  </div>

                  <div className="input-item-with-label">
                    <label
                      htmlFor="orgWithholdingExempt"
                      style={{
                        width: "90px",
                        alignSelf: "flex-start",
                      }}
                    />
                    <ToggleSwitch
                      value={orgWithholdingExempt}
                      onChange={(newValue) => setOrgWithholdingExempt(newValue)}
                      label={t('commWhExcempt').toUpperCase()}
                      labelPosition="end"
                      labelWidth="max-content"
                      border="N"
                    />
                  </div>
                </div>
              </ExpandableComponent>
              {/* <hr className="separator-h" /> */}

              {/* <hr className="separator-h" /> */}
              <Segmented
                defaultValue="more"
                style={{
                  margin: "8px 5px",
                  height: '40px',
                }}
                className="custom-segmented"
                onChange={(value) => setAlignValue(value)}
                options={[
                  { label: <span style={{ fontSize: "15px" }}>{t('more').toUpperCase()}</span>, value: 'more' },
                  { label: <span style={{ fontSize: "15px" }}>{t('missionVision').toUpperCase()}</span>, value: 'missionVision' },
                  { label: <span style={{ fontSize: "15px" }}>{t('generation').toUpperCase()}</span>, value: 'numberGen' },
                  { label: <span style={{ fontSize: "15px" }}>{t('signatures').toUpperCase()}</span>, value: 'signatures' },
                  { label: <span style={{ fontSize: "15px" }}>{t('dmvic').toUpperCase()}</span>, value: 'dmvic' },
                  { label: <span style={{ fontSize: "15px" }}>{t('bima').toUpperCase()}</span>, value: 'bima' },
                  { label: <span style={{ fontSize: "15px" }}>{t('mpesa').toUpperCase()}</span>, value: 'mpesa' },
                  { label: <span style={{ fontSize: "15px" }}>{t('airtel').toUpperCase()}</span>, value: 'airtel' },
                ]}
              />
              {alignValue === "more" &&
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1, transition: { duration: 1 } }}
                  exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                  {/* Business Units */}
                  <ExpandableComponent
                    title={t('businessUnits').toUpperCase()}
                    subtitle={["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                      <CircularButton
                        currentTheme={currentTheme}
                        onClick={async () => {
                          try {
                            setCurrencyAction("addUnit");
                            setUnitType({
                              value: "Branch",
                              label: "Branch",
                            });
                            setUnitStatus({
                              value: "Active",
                              label: "Active",
                            })
                            setOpenAddUnit(true);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        color="#0ea5a4"
                        icon={<MdAdd />}
                        width={"35px"}
                        height={"35px"} />
                    }
                    defaultExpanded={true}
                  >
                    <div className="table-content">
                      <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                        <Table sx={{ width: "max-content", border: 'none' }}>
                          <TableHead className="tablehead">
                            <TableRow className="tablerow">
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                #
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "120px" }}>
                                <span>{t('code').toUpperCase()}</span>
                              </TableCell>
                              <TableCell className="table-cell left" style={{ width: "auto" }}>
                                <span>{t('name').toUpperCase()}</span>
                              </TableCell>
                              <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                <span>{t('status').toUpperCase()}</span>
                              </TableCell>
                              {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                  <span>{t('action').toUpperCase()}</span>
                                </TableCell>}
                            </TableRow>
                          </TableHead>
                          <TableBody className="tablebody">
                            {slicedOrgUnits?.map((row, index) => (
                              <TableRow
                                key={row?._id}
                                className={`${selectedOrgUnit?._id === row?._id ? "tablerow current" : "tablerow"}`}
                                onClick={() => {
                                  try {
                                    setSelectedOrgUnit(row);
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                              >
                                <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                  {currentOrgUnitPage * rowsPerPage + index + 1}
                                </TableCell>
                                <TableCell className="table-cell left" style={{ maxWidth: "120px" }}>
                                  {/* <input
                              id="unit_code"
                              name="unit_code"
                              value={row?.unit_code}
                              onChange={(e) => handleOrgUnits(e, index)}
                              style={{ width: "100%" }}
                              className="form-input-item"
                              disabled
                            /> */}
                                  <h1 className="sub-title">{row?.unit_code}</h1>
                                </TableCell>
                                <TableCell className="table-cell left" style={{ width: "auto" }}>
                                  <div className="input-item-with-label" style={{ width: "100%" }}>
                                    <input
                                      id="unit_name"
                                      name="unit_name"
                                      value={row?.unit_name}
                                      onChange={(e) => handleOrgUnitsChange(e, row?._id)}
                                      style={{ width: "100%" }}
                                      className="form-input-item table"
                                      disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                    />
                                  </div>
                                </TableCell>
                                <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                  <span className={`sub-title status ${getCssValue(row?.unit_status)}`}>{row?.unit_status}</span>
                                </TableCell>
                                {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                  <TableCell className="table-cell center" style={{ maxWidth: "100px", }}>
                                    <CircularButton
                                      currentTheme={currentTheme}
                                      onClick={() => {
                                        try {
                                          setSelectedOrgUnit(row);
                                          setCurrencyAction("editUnit");

                                          setUnitCode(row?.unit_code);
                                          setUnitName(row?.unit_name);
                                          setUnitType({
                                            value: row?.unit_type,
                                            label: row?.unit_type,
                                          });
                                          setUnitAddress1(row?.unit_address1);
                                          setUnitEmail(row?.unit_email);
                                          setUnitPhone(row?.unit_phone);
                                          setUnitStatus({
                                            value: row?.unit_status,
                                            label: row?.unit_status,
                                          });
                                          setUnitBankAc({
                                            value: row?.unit_bank_ac,
                                            label: row?.unit_bank_ac_xx,
                                          });

                                          setUnitLatitude(row?.unit_latitude);
                                          setUnitLongitude(row?.unit_longitude);
                                          setUnitPlaceName(row?.unit_place_name);

                                          setOpenAddUnit(true);
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }} icon={<MdEdit color="blue" />} width={"30px"} height={"30px"} />
                                  </TableCell>}
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                        {orgUnits?.length > rowsPerPage &&
                          <TablePagination
                            rowsPerPageOptions={[5]}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleOrgUnitsRowsPerPage}
                            component="div"
                            count={orgUnits?.length}
                            rows={orgUnits}
                            page={currentOrgUnitPage}
                            onPageChange={handleOrgUnitsPageChange}
                          />}
                      </TableContainer>
                    </div>
                  </ExpandableComponent>
                  {/* End of Business Units */}
                  {/* Organization Administrators. Can be viewed by administrators and super administrators only */}
                  {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                    <ExpandableComponent
                      title={t('administrators').toUpperCase()}
                      subtitle={<div className="input-item-with-label">
                        <label htmlFor="admin_id">{t('user').toUpperCase()}</label>
                        <Select
                          id="admin_id"
                          name="admin_id"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="250px"
                          value={selectedAdminToAdd}
                          onChange={(selectedOption) => setSelectedAdminToAdd(selectedOption)}
                          options={users}
                          isSearchable={true}
                          placeholder={t('users')}
                        />
                        <span style={{ width: "10px" }} />
                        <CircularButton
                          currentTheme={currentTheme}
                          onClick={handleAddAdmin}
                          color="#0ea5a4"
                          icon={<MdAdd />}
                          width={"35px"}
                          height={"35px"} />
                      </div>}
                      defaultExpanded={true}
                    >
                      {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                        <div className="org-admins-wrapper">
                          {orgAdmins.length > 0 && (
                            <>
                              {orgAdmins?.map((row, index) => (
                                <div key={row?._id} className="single-item">
                                  <span
                                    style={{
                                      alignContent: "flex-start",
                                      fontWeight: "bold",
                                      fontSize: "20px",
                                    }}
                                  >
                                    {index + 1}.
                                  </span>
                                  <div className="user">
                                    <img
                                      src={row?.usr_photo_url || "/img/noavatar.jpg"}
                                      alt=""
                                    />
                                    <div className="user-org-view">
                                      <span className="user-full-name">
                                        {row?.usr_full_name}
                                      </span>
                                    </div>
                                    {row?.superadmin === "Y" && <span>{t('superAdmin')}</span>}
                                    {row?.superadmin === "N" && (
                                      <Tooltip
                                        title={`Remove ${row?.usr_full_name} as ADMINISTRATOR from ${orgName}`}
                                        placement="right"
                                      >
                                        <MdClose
                                          size={24}
                                          style={{
                                            borderRadius: "5px",
                                            padding: "3px",
                                            cursor: "pointer",
                                            color: "rgba(172, 33, 9)",
                                            backgroundColor: "rgba(172, 33, 9, 0.5)",
                                          }}
                                          onClick={() => {
                                            try {
                                              const action_text = `Do you want to remove ${row?.usr_full_name} as ADMINISTRATOR from ${orgName}?`;
                                              setObjectToAction({
                                                object_id: row?._id,
                                                action_text: action_text,
                                              });
                                              setConfirmDialogAction("removeAdmin");
                                              setIsConfirmDialogOpen(true);
                                            } catch (error) {
                                              console.log(error);
                                            }
                                          }}
                                        />
                                      </Tooltip>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </>
                          )}
                        </div>}
                    </ExpandableComponent>}
                  {/* End of Administrators */}
                </motion.div>}
              {/* Number generation */}
              {alignValue === "missionVision" &&
                <motion.div
                  className="mission-details-wrapper"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1, transition: { duration: 1 } }}
                  exit={{ opacity: 0, transition: { duration: 1 } }}>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="org_mission"
                      style={{
                        width: "100px",
                        alignSelf: "flex-start",
                      }}
                    >
                      {t('mission').toUpperCase()}
                    </label>
                    <textarea
                      id="org_mission"
                      name="org_mission"
                      type="text"
                      rows={3}
                      placeholder={t('mission').toUpperCase()}
                      value={orgMission}
                      onChange={(e) => setOrgMission(e.target.value)}
                      className="form-input-item"
                      style={{ width: "100%" }}
                      disabled={!["superadmin"].includes(currentUser.user_type_xx)}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="org_vision"
                      style={{
                        width: "100px",
                        alignSelf: "flex-start",
                      }}
                    >
                      {t('vision').toUpperCase()}
                    </label>
                    <textarea
                      id="org_vision"
                      name="org_vision"
                      type="text"
                      rows={3}
                      placeholder={t('vision').toUpperCase()}
                      value={orgVision}
                      onChange={(e) => setOrgVision(e.target.value)}
                      className="form-input-item"
                      style={{ width: "100%" }}
                      disabled={!["superadmin"].includes(currentUser.user_type_xx)}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="org_about_us"
                      style={{
                        width: "100px",
                        alignSelf: "flex-start",
                      }}
                    >
                      {t('aboutUs').toUpperCase()}
                    </label>
                    <textarea
                      id="org_about_us"
                      name="org_about_us"
                      type="text"
                      rows={10}
                      placeholder={t('aboutUs').toUpperCase()}
                      value={orgAboutUs}
                      onChange={(e) => setOrgAboutUs(e.target.value)}
                      className="form-input-item"
                      style={{ width: "100%" }}
                      disabled={!["superadmin"].includes(currentUser.user_type_xx)}
                    />
                  </div>
                </motion.div>}
              {alignValue === "numberGen" &&
                <ExpandableComponent
                  title={t('numberGeneration').toUpperCase()}
                  subtitle={["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                    <CircularButton
                      currentTheme={currentTheme}
                      onClick={() => setIsNumGenDialogOpened(true)}
                      color="#0ea5a4"
                      icon={<MdAdd />}
                      width={"35px"}
                      height={"35px"} />}
                  defaultExpanded={true}
                >
                  <div className="table-content">
                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                      <Table sx={{ width: "max-content", border: 'none' }}>
                        <TableHead className="tablehead">
                          <TableRow className="tablerow">
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              #
                            </TableCell>
                            <TableCell className="table-cell left" style={{ width: "auto", }}>
                              <span>{t('type').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "150px" }}>
                              <span>{t('use').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                              <span>{t('auto').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "150px" }}>
                              <span>{t('currentNo').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "70px" }}>
                              <span>{t('prefix').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "70px" }}>
                              <span>{t('suffix').toUpperCase()}</span>
                            </TableCell>
                            {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                              <TableCell className="table-cell center" style={{ maxWidth: "100px", }}>
                                <span>{t('action').toUpperCase()}</span>
                              </TableCell>}
                          </TableRow>
                        </TableHead>
                        <TableBody className="tablebody">
                          {slicedNumGens?.map((row, index) => (
                            <TableRow
                              key={row?._id}
                              className={`${selectedNumberGen?._id === row?._id ? "tablerow current" : "tablerow"}`}
                              onClick={() => setSelectedNumberGen(row)}
                            >
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                {currentNumGenPage * rowsPerPage + index + 1}
                              </TableCell>
                              <TableCell className="table-cell left" style={{ width: "auto" }}>
                                <h1 className="sub-title">{row?.gen_type}</h1>
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                                <MuiSelect
                                  id="gen_entity_type"
                                  name="gen_entity_type"
                                  value={row?.gen_entity_type}
                                  onChange={(e) => handleNumGens(e.target.value, row?._id, "gen_entity_type")}
                                  style={{ width: "100%" }}
                                  variant="outlined"
                                  size="small"
                                  disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                  sx={currentTheme === "dark" ? muiSelectStyles_dark : muiSelectStyles_light(false, false, 'max-content', '36px').select}
                                  MenuProps={{
                                    PaperProps: {
                                      sx: currentTheme === "dark" ? muiSelectStyles_dark().menu.paper : muiSelectStyles_light().menu.paper
                                    }
                                  }}
                                >
                                  <MenuItem value="sequence" sx={{ height: '36px' }}>{t('sequence')}</MenuItem>
                                  {row?.gen_type === "Entities" && <MenuItem value="name" sx={{ height: '36px' }}>{t('name')}</MenuItem>}
                                </MuiSelect>
                              </TableCell>
                              <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                <ToggleSwitch
                                  value={row?.gen_auto}
                                  onChange={(newValue) => handleNumGens(newValue, row?._id, "gen_auto")}
                                  label=""
                                  labelPosition="end"
                                  labelWidth="max-content"
                                  border="N"
                                />
                              </TableCell>
                              <TableCell className="table-cell center" style={{ maxWidth: "150px" }}>
                                <div className="input-item-with-label">
                                  <input
                                    id="gen_current_no"
                                    name="gen_current_no"
                                    value={row?.gen_current_no}
                                    onChange={(e) => handleNumGens(e.target.value, row?._id, "gen_current_no")}
                                    style={{ width: "100%", textAlign: "right" }}
                                    className="form-input-item table"
                                    disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                  />
                                </div>
                              </TableCell>
                              <TableCell className="table-cell center" style={{ maxWidth: "70px" }}>
                                <div className="input-item-with-label">
                                  <input
                                    id="gen_prefix"
                                    name="gen_prefix"
                                    value={row?.gen_prefix}
                                    onChange={(e) => handleNumGens(e.target.value, row?._id, "gen_prefix")}
                                    style={{ width: "100%" }}
                                    className="form-input-item table"
                                    disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                  />
                                </div>
                              </TableCell>
                              <TableCell className="table-cell center" style={{ maxWidth: "70px" }}>
                                <div className="input-item-with-label">
                                  <input
                                    id="gen_surfix"
                                    name="gen_surfix"
                                    value={row?.gen_surfix}
                                    onChange={(e) => handleNumGens(e.target.value, row?._id, "gen_surfix")}
                                    style={{ width: "100%" }}
                                    className="form-input-item table"
                                    disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                  />
                                </div>
                              </TableCell>
                              {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                <TableCell className="table-cell center" style={{ maxWidth: "100px", }}>
                                  <CircularButton
                                    currentTheme={currentTheme}
                                    onClick={() => {
                                      try {
                                        let action_text = `Delete ${row?.gen_type}?`;
                                        setObjectToAction({
                                          object_id: row?._id,
                                          action_text: action_text,
                                          new_doc_status: "deleteNumGen",
                                        });
                                        setConfirmDialogAction("deleteNumGen");
                                        setIsConfirmDialogOpen(true);
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                    color="#E53935"
                                    icon={<MdDelete />}
                                    width={"30px"}
                                    height={"30px"} />
                                </TableCell>}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      {numberGens?.length > rowsPerPage &&
                        <TablePagination
                          rowsPerPageOptions={[5]}
                          rowsPerPage={rowsPerPage}
                          onRowsPerPageChange={handleNumGensRowsPerPage}
                          component="div"
                          count={numberGens?.length}
                          rows={numberGens}
                          page={currentNumGenPage}
                          onPageChange={handleNumGensPageChange}
                        />}
                    </TableContainer>
                  </div>
                </ExpandableComponent>}
              {alignValue === "reports" &&
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1, transition: { duration: 1 } }}
                  exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      padding: "5px",
                    }}
                  >
                    <span>{t('reports')}</span>
                  </div>
                </motion.div>}
              {alignValue === "signatures" &&
                <AdDocumentSign />}
              {alignValue === "dmvic" &&
                <motion.div
                  className="dmvic-wrapper"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1, transition: { duration: 1 } }}
                  exit={{ opacity: 0, transition: { duration: 1 } }}>
                  <div className="dmvic-settings">
                    <div className="dmvic-settings-left">
                      <div className="input-item-with-label">
                        <label htmlFor="token_api_username"
                          style={{ width: "120px" }}
                          className="form-dropdown-label">
                          {t('username').toUpperCase()}
                        </label>
                        <input
                          id="token_api_username"
                          name="token_api_username"
                          disabled={!["superadmin"].includes(currentUser.user_type_xx)}
                          placeholder={t('username').toUpperCase()}
                          className="form-input-item"
                          style={{ width: "100%" }}
                          value={orgDmvicSettings?.token_api_username}
                          onChange={(e) => updateDmvicField('token_api_username', e.target.value)}
                        />
                      </div>

                      <div className="input-item-with-label">
                        <label htmlFor="token_api_password"
                          style={{ width: "120px" }}
                          className="form-dropdown-label">
                          {t('password').toUpperCase()}
                        </label>
                        <input
                          id="token_api_password"
                          name="token_api_password"
                          type={["superadmin"].includes(currentUser.user_type_xx) ? "text" : "password"}
                          disabled={!["superadmin"].includes(currentUser.user_type_xx)}
                          placeholder={t('password').toUpperCase()}
                          className="form-input-item"
                          style={{ width: "100%" }}
                          value={orgDmvicSettings?.token_api_password}
                          onChange={(e) => updateDmvicField('token_api_password', e.target.value)}
                        />
                      </div>

                      <div className="input-item-with-label">
                        <label htmlFor="token_cert_password"
                          style={{ width: "120px" }}
                          className="form-dropdown-label">
                          {t('certPw').toUpperCase()}
                        </label>
                        <input
                          id="token_cert_password"
                          name="token_cert_password"
                          type={["superadmin"].includes(currentUser.user_type_xx) ? "text" : "password"}
                          disabled={!["superadmin"].includes(currentUser.user_type_xx)}
                          placeholder={t('certPw').toUpperCase()}
                          className="form-input-item"
                          style={{ width: "100%" }}
                          value={orgDmvicSettings?.token_cert_password}
                          onChange={(e) => updateDmvicField('token_cert_password', e.target.value)}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="token_client_id"
                          style={{ width: "120px" }}
                          className="form-dropdown-label">
                          {t('clientId').toUpperCase()}
                        </label>
                        <input
                          id="token_client_id"
                          name="token_client_id"
                          type={["superadmin"].includes(currentUser.user_type_xx) ? "text" : "password"}
                          disabled={!["superadmin"].includes(currentUser.user_type_xx)}
                          placeholder={t('clientId').toUpperCase()}
                          className="form-input-item"
                          style={{ width: "100%" }}
                          value={orgDmvicSettings?.token_client_id}
                          onChange={(e) => updateDmvicField('token_client_id', e.target.value)}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="token_company_id"
                          style={{ width: "120px" }}
                          className="form-dropdown-label">
                          {t('companyId').toUpperCase()}
                        </label>
                        <input
                          id="token_company_id"
                          name="token_company_id"
                          type={["superadmin"].includes(currentUser.user_type_xx) ? "text" : "password"}
                          disabled={!["superadmin"].includes(currentUser.user_type_xx)}
                          placeholder={t('companyId').toUpperCase()}
                          className="form-input-item"
                          style={{ width: "100%" }}
                          value={orgDmvicSettings?.token_company_id}
                          onChange={(e) => updateDmvicField('token_company_id', e.target.value)}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="token_dmvic_flag"
                          style={{ width: "120px" }}
                          className="form-dropdown-label">
                          {t('flag').toUpperCase()}
                        </label>
                        <Select
                          id="token_dmvic_flag"
                          name="token_dmvic_flag"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width={"100%"}
                          value={dmvicFlag.find(option => option.value === orgDmvicSettings?.token_dmvic_flag) || null}
                          onChange={(selectedOption) => updateDmvicField("token_dmvic_flag", selectedOption?.value)}
                          options={dmvicFlag}
                          placeholder={t('flag').toUpperCase()}
                        />
                      </div>
                    </div>
                    <div className="dmvic-settings-right">
                      <div className="input-item-with-label" style={{ alignItems: "center", width: "100%", paddingLeft: "90px" }}>
                        <CustomLoadingButton
                          currentTheme={currentTheme}
                          iconPosition="end"
                          borderRadiusType="both"
                          variant="tint"
                          color="#E53935"
                          tooltip={"Click to refresh DMVIC token"}
                          endIcon={<GrSync />}
                          width={"100%"}
                          onClick={async () => {
                            try {
                              setIsProcessing(true);
                              setIsProcessingTitle(t('generatingDmvicToken'));
                              const res = await newRequest.get("dmvic/generateToken");
                              setIsProcessingTitle("");
                              logData("token", res.data);
                              if (res.data?.success === true) {
                                await fetchOrganization();
                                setIsProcessing(false);
                                showToast(t('tokenRefreshed'), "success");
                              } else {
                                setIsProcessing(false);
                                setNotifyDialogTitle("Error!");
                                setNotifyDialogText(res.data?.error);
                                setIsNotifyDialogOpen(true);
                                return;
                              }
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >
                          {t('refreshToken')}
                        </CustomLoadingButton>
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="token_issued"
                          style={{ width: "100px" }}
                          className="form-dropdown-label">
                          {t('issued').toUpperCase()}
                        </label>
                        <span className="sub-title" style={{ width: "100%", height: "40px", alignContent: "center" }}>{orgDmvicSettings?.token_issued_xx}</span>
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="token_expiry"
                          style={{ width: "100px" }}
                          className="form-dropdown-label">
                          {t('expiry').toUpperCase()}
                        </label>
                        <span className="sub-title" style={{ width: "100%", height: "40px", alignContent: "center" }}>{orgDmvicSettings?.token_expiry_xx}</span>
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="portal_username"
                          style={{ width: "100px" }}
                          className="form-dropdown-label">
                          {t('portalUn').toUpperCase()}
                        </label>
                        <input
                          id="portal_username"
                          name="portal_username"
                          type="text"
                          disabled={!["superadmin"].includes(currentUser.user_type_xx)}
                          placeholder={t('portalUn').toUpperCase()}
                          className="form-input-item"
                          style={{ width: "100%" }}
                          value={orgDmvicSettings?.portal_username}
                          onChange={(e) => updateDmvicField('portal_username', e.target.value)}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="portal_password"
                          style={{ width: "100px" }}
                          className="form-dropdown-label">
                          {t('portalPw').toUpperCase()}
                        </label>
                        <input
                          id="portal_password"
                          name="portal_password"
                          type={["superadmin"].includes(currentUser.user_type_xx) ? "text" : "password"}
                          disabled={!["superadmin"].includes(currentUser.user_type_xx)}
                          placeholder={t('portalPw').toUpperCase()}
                          className="form-input-item"
                          style={{ width: "100%" }}
                          value={orgDmvicSettings?.portal_password}
                          onChange={(e) => updateDmvicField('portal_password', e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </motion.div>}

              {alignValue === "bima" &&
                <motion.div
                  className="bima-wrapper"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1, transition: { duration: 1 } }}
                  exit={{ opacity: 0, transition: { duration: 1 } }}>
                  <div className="bima-settings">
                    <div className="bima-settings-left">
                      <span className="sub-title">{t('endpoints').toUpperCase()}</span>
                      <div className="input-item-with-label" style={{ gap: "5px" }}>
                        <Select
                          id="endpoint_type"
                          name="endpoint_type"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width={"150px"}
                          value={selectedEndpoint}
                          onChange={(selectedOption) => setSelectedEndpoint(selectedOption)}
                          options={endpointTypes}
                          placeholder={t('type')}
                        />
                        <input
                          id="endpoint_address"
                          name="endpoint_address"
                          type="text"
                          placeholder={t('address')}
                          className="form-input-item"
                          style={{ width: "100%" }}
                          value={endpointAddress}
                          onChange={(e) => setEndpointAddress(e.target.value)}
                        />
                        <CircularButton
                          currentTheme={currentTheme}
                          onClick={async () => {
                            try {
                              if (!selectedEndpoint?.value) {
                                setNotifyDialogTitle(t('error'));
                                setNotifyDialogText(`Select endpoint type`);
                                setIsNotifyDialogOpen(true);
                                return;
                              }
                              if (!endpointAddress) {
                                setNotifyDialogTitle(t('error'));
                                setNotifyDialogText("Enter endpoint address");
                                setIsNotifyDialogOpen(true);
                                return;
                              }
                              setIsProcessing(true);
                              const res = await newRequest.post(
                                "/org/addBimaEndpoint",
                                {
                                  endpoint_type: selectedEndpoint?.value,
                                  endpoint_address: endpointAddress,
                                  endpoint_remarks: selectedEndpoint?.value,
                                }
                              );

                              if (res.data?.msg === "added") {
                                setOrgBimaEndpoints((prevParams) => [...prevParams, res.data?.doc]);
                                setIsProcessing(false);
                                setSelectedEndpoint(null);
                                setEndpointAddress("");
                                showToast(t('added'), "success");
                              } else if (res.data?.msg === "updated") {
                                const updatedEndpoint = res.data?.doc;
                                setOrgBimaEndpoints((prevData) => {
                                  return prevData.map((row) =>
                                    row._id === updatedEndpoint._id ? updatedEndpoint : row
                                  );
                                });
                                setIsProcessing(false);
                                setSelectedEndpoint(null);
                                setEndpointAddress("");
                                showToast(t('updated'), "success");
                              } else {
                                showToast("Error adding endpoint!", "error");
                              }
                            } catch (error) {
                              setIsProcessing(false);
                              console.log(error);
                            }
                          }}
                          color="#0ea5a4"
                          icon={<MdAdd />}
                          width={"30px"}
                          height={"30px"} />
                      </div>
                      <div className="table-content">
                        <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                          <Table sx={{ width: "max-content", border: 'none' }}>
                            <TableBody className="tablebody">
                              {orgBimaEndpoints?.map((row, index) => (
                                <TableRow
                                  key={row._id}
                                  className={`${selectedOrgEndpoint?._id === row._id ? "tablerow current" : "tablerow"}`}
                                  onClick={() => setSelectedOrgEndpoint(row)}
                                >
                                  <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                    {index + 1}
                                  </TableCell>
                                  <TableCell className="table-cell left" style={{ width: "auto" }}>
                                    <span className="sub-title nowrap">{row?.endpoint_type} </span>
                                    <span className="sub-title xrsmall soft">{row?.endpoint_address} </span>
                                  </TableCell>
                                  <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                    <CircularButton
                                      currentTheme={currentTheme}
                                      onClick={async () => {
                                        try {
                                          const res = await newRequest.delete(`/org/removeBimaEndpoint/${row._id}`);
                                          if (res.data?.msg === "removed") {
                                            setOrgBimaEndpoints((prev) => prev.filter(val => val?._id !== row._id));
                                            showToast(t('removed'), "success");
                                          } else {
                                            showToast("Error removing!", "error");
                                          }
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }}
                                      color="#E53935"
                                      tooltip={`Remove ${row?.endpoint_type}`}
                                      icon={<MdDelete />}
                                      width={"30px"}
                                      height={"30px"} />
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </div>
                    </div>
                    <div className="bima-settings-right">
                      <span className="sub-title">{t('categories').toUpperCase()}</span>
                      <div className="input-item-with-label" style={{ gap: "5px" }}>
                        <Select
                          id="catg_type"
                          name="catg_type"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width={"100%"}
                          value={selectedCategory}
                          onChange={(selectedOption) => setSelectedCategory(selectedOption)}
                          options={entityCategories}
                          placeholder={t('category')}
                        />
                        <CircularButton
                          currentTheme={currentTheme}
                          onClick={async () => {
                            try {
                              if (!selectedCategory?.value) {
                                setNotifyDialogTitle(t('error'));
                                setNotifyDialogText(`Select category`);
                                setIsNotifyDialogOpen(true);
                                return;
                              }

                              setIsProcessing(true);
                              const res = await newRequest.post(
                                "/org/addBimaCategory",
                                {
                                  catg_type: selectedCategory?.value,
                                  catg_remarks: selectedCategory?.value,
                                }
                              );

                              if (res.data?.msg === "added") {
                                setOrgBimaCategory((prevData) => [...prevData, res.data?.doc]);
                                setIsProcessing(false);
                                setSelectedCategory(null);
                                showToast(t('added'), "success");
                              } else if (res.data?.msg === "updated") {
                                const updatedCatg = res.data?.doc;
                                setOrgBimaCategory((prevData) => {
                                  return prevData.map((row) =>
                                    row._id === updatedCatg._id ? updatedCatg : row
                                  );
                                });
                                setIsProcessing(false);
                                setSelectedEndpoint(null);
                                showToast(t('updated'), "success");
                              } else {
                                showToast("Error adding category!", "error");
                              }
                            } catch (error) {
                              setIsProcessing(false);
                              console.log(error);
                            }
                          }}
                          color="#0ea5a4"
                          icon={<MdAdd />}
                          width={"30px"}
                          height={"30px"} />
                      </div>
                      <div className="table-content">
                        <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                          <Table sx={{ width: "max-content", border: 'none' }}>
                            <TableBody className="tablebody">
                              {orgBimaCategory?.map((row, index) => (
                                <TableRow
                                  key={row?._id}
                                  className={`${selectedOrgCategory?._id === row?._id ? "tablerow current" : "tablerow"}`}
                                  onClick={() => setSelectedOrgCategory(row)}
                                >
                                  <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                    {index + 1}
                                  </TableCell>
                                  <TableCell className="table-cell left" style={{ width: "auto" }}>
                                    <span className="sub-title nowrap">{row?.catg_type} </span>
                                    <span className="sub-title xrsmall soft">{row?.catg_type} </span>
                                  </TableCell>
                                  <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                    <CircularButton
                                      currentTheme={currentTheme}
                                      onClick={async () => {
                                        try {
                                          const res = await newRequest.delete(`/org/removeBimaCategory/${row._id}`);
                                          if (res.data?.msg === "removed") {
                                            setOrgBimaCategory((prev) => prev.filter(val => val?._id !== row._id));
                                            showToast(t('removed'), "success");
                                          } else {
                                            showToast("Error removing!", "error");
                                          }
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }}
                                      color="#E53935"
                                      tooltip={`Remove ${row?.catg_type}`}
                                      icon={<MdDelete />}
                                      width={"30px"}
                                      height={"30px"} />
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </div>
                    </div>
                  </div>
                </motion.div>}

              {alignValue === "mpesa" &&
                <motion.div
                  className="mpesa-wrapper"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1, transition: { duration: 1 } }}
                  exit={{ opacity: 0, transition: { duration: 1 } }}>
                  mpesa settings
                </motion.div>}

              {alignValue === "airtel" &&
                <motion.div
                  className="airtel-wrapper"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1, transition: { duration: 1 } }}
                  exit={{ opacity: 0, transition: { duration: 1 } }}>
                  airtel settings
                </motion.div>}

            </div>
          </div>
          <div className="right-wrapper">
            <div className="right-content">
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginBottom: "5px" }}>
                <h2 className="main-title">{t('summary').toUpperCase()}</h2>
                <span style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px", paddingRight: "5px" }}>
                  {/* This part shows if the menu was opened from home screen */}
                  {/* {showBack === "Y" && <hr className="separator-v" />} */}
                  {showBack === "Y" &&
                    <CircularButton
                      currentTheme={currentTheme}
                      onClick={() => navigate(-1)}
                      color="#03A9F4"
                      icon={<MdClose />}
                      width={"30px"}
                      height={"30px"} />}
                </span>
              </div>
              <hr className="separator-h" />
              <h1 className="sub-title">{`${t('opened')} ${orgRecordData?.time_ago_xx}`}</h1>
              <h1 className="sub-title">{`${t('users')} ${orgStats?.users_count}`}</h1>
              <h1 className="sub-title">{`${t('products')} ${orgStats?.uw_products}`}</h1>
              <hr className="separator-h" />
              <h1 className="main-title">{t('stats').toUpperCase()}</h1>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "column",
                }}
              >
                {orgStats?.entities_stats?.map((st) => (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      margin: "5px 0px",
                      gap: "10px",
                    }}
                    key={st._id}
                  >
                    <h1 className="sub-title">{st?.aent_name}</h1>
                    <h1 className="sub-title">{numeral(st?.count).format("0,0")}</h1>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle={t('confirmation')}
        dialogContent={<p dangerouslySetInnerHTML={{ __html: objectToAction.action_text }} />}
      />
      {isCodeDialogOpened && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{`${currencyAction === "addSysCode" ? t('addCode').toUpperCase() : t('addType').toUpperCase()}`}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setIsCodeDialogOpened(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-actions">
              {currencyAction === "addSysCode" && (
                <CustomLoadingButton
                  currentTheme={currentTheme}
                >
                  {t('add').toUpperCase()}
                </CustomLoadingButton>
              )}
              {currencyAction === "addSysType" && (
                <CustomLoadingButton
                  currentTheme={currentTheme}
                >
                  {t('add').toUpperCase()}
                </CustomLoadingButton>
              )}
            </div>
          </div>
        </motion.div>
      )}

      {isNumGenDialogOpened &&
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('add').toUpperCase()}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setIsNumGenDialogOpened(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <div className="input-item-with-label">
                <label
                  htmlFor="new_doc"
                  style={{ width: "50px" }}
                >
                  {t('type').toUpperCase()}
                </label>
                <Select
                  id="new_doc"
                  name="new_doc"
                  width="160px"
                  value={newDocType}
                  onChange={(selectedOption) => {
                    try {
                      setNewDocType(selectedOption);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                  options={documentOptions}
                  isSearchable={true}
                  placeholder={t('type').toUpperCase()}
                  menuPortalTarget={document.body}
                  styles={{
                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                    menuPortal: base => ({
                      ...base,
                      zIndex: 9999,
                    })
                  }}
                />
              </div>
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton
                currentTheme={currentTheme}
                onClick={handleNumGenAction}
              >
                {t('add').toUpperCase()}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>}

      {/* add organization unit */}
      {openAddUnit && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              {currencyAction === "addUnit" && <h1 className="main-title">ADD BUSINESS UNIT</h1>}
              {currencyAction === "editUnit" && <h1 className="main-title" style={{ textTransform: "uppercase" }}>{`${t('edit').toUpperCase()} ${selectedOrgUnit.unit_name}`}</h1>}
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => {
                  try {
                    setSelectedOrgUnit(null);
                    setCurrencyAction("none");
                    setUnitCode("");
                    setUnitName("");
                    setUnitType(null);
                    setUnitAddress1("");
                    setUnitEmail("");
                    setUnitPhone("");
                    setUnitStatus(null);
                    setUnitBankAc(null);
                    setUnitLatitude(null);
                    setUnitLongitude(null);
                    setUnitPlaceName(null);
                    setOpenAddUnit(false);
                  } catch (error) {
                    console.log(error);
                  }
                }} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                <div className="input-item-with-label">
                  <label htmlFor="unit_code" style={{ width: "100px" }}>
                    {t('code').toUpperCase()}
                  </label>
                  <input
                    name="unit_code"
                    type="text"
                    placeholder={t('code').toUpperCase()}
                    className="form-input-item"
                    style={{ width: "130px" }}
                    value={unitCode}
                    onChange={(e) => setUnitCode(e.target.value)}
                    disabled={currencyAction === "editUnit"}
                  />
                </div>
                <div className="input-item-with-label">
                  <label
                    htmlFor="unit_status"
                    style={{ width: "80px" }}
                  >
                    {t('status').toUpperCase()}
                  </label>
                  <Select
                    id="unit_status"
                    name="unit_status"
                    styles={{
                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                      menuPortal: base => ({
                        ...base,
                        zIndex: 9999,
                      })
                    }}
                    width="130px"
                    value={unitStatus}
                    onChange={(selectedOption) => {
                      try {
                        setUnitStatus(selectedOption);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                    options={statusOptions}
                    isSearchable={false}
                    placeholder={t('status').toUpperCase()}
                  />
                </div>
              </div>
              <div className="input-item-with-label">
                <label htmlFor="unit_name" style={{ width: "100px" }}>
                  {t('name').toUpperCase()}
                </label>
                <input
                  name="unit_name"
                  type="text"
                  placeholder={t('name').toUpperCase()}
                  className="form-input-item"
                  style={{ width: "350px" }}
                  value={unitName}
                  onChange={(e) => setUnitName(e.target.value)}
                />
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="unit_type"
                  style={{ width: "100px" }}
                >
                  {t('type').toUpperCase()}
                </label>
                <Select
                  id="unit_type"
                  name="unit_type"
                  styles={{
                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                    menuPortal: base => ({
                      ...base,
                      zIndex: 9999,
                    })
                  }}
                  width="350px"
                  value={unitType}
                  onChange={(selectedOption) => {
                    try {
                      setUnitType(selectedOption);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                  options={unitTypeOptions}
                  isSearchable={false}
                  placeholder={t('type').toUpperCase()}
                />
              </div>
              <div className="input-item-with-label">
                <label htmlFor="unit_address1" style={{ width: "100px", alignSelf: "flex-start" }}>
                  {t('address').toUpperCase()}
                </label>
                <textarea
                  name="unit_address1"
                  type="text"
                  placeholder={t('address').toUpperCase()}
                  className="form-input-item"
                  style={{ width: "350px" }}
                  value={unitAddress1}
                  rows={3}
                  onChange={(e) => setUnitAddress1(e.target.value)}
                />
              </div>
              <div className="input-item-with-label">
                <label htmlFor="unit_email" style={{ width: "100px" }}>
                  {t('email').toUpperCase()}
                </label>
                <input
                  name="unit_email"
                  type="email"
                  placeholder={t('email').toUpperCase()}
                  className="form-input-item"
                  style={{ width: "350px" }}
                  value={unitEmail}
                  onChange={(e) => setUnitEmail(e.target.value)}
                />
              </div>
              <div className="input-item-with-label">
                <label htmlFor="unit_phone" style={{ width: "100px" }}>
                  {t('phone').toUpperCase()}
                </label>
                <input
                  name="unit_phone"
                  type="text"
                  placeholder={t('phone').toUpperCase()}
                  className="form-input-item"
                  style={{ width: "350px" }}
                  value={unitPhone}
                  onChange={(e) => setUnitPhone(e.target.value)}
                />
              </div>
              <div className="input-item-with-label">
                <label htmlFor="unit_bank_ac"
                  className="form-dropdown-label"
                  style={{ width: "100px" }}>
                  {t('bankAc').toUpperCase()}
                </label>
                <Select
                  id="unit_bank_ac"
                  name="unit_bank_ac"
                  menuPortalTarget={document.body}
                  styles={{
                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                    menuPortal: base => ({
                      ...base,
                      zIndex: 9999,
                    })
                  }}
                  width="350px"
                  value={unitBankAc}
                  onChange={(selectedOption) => setUnitBankAc(selectedOption)}
                  options={bankAccounts}
                  isSearchable={true}
                  placeholder={t('bankAc').toUpperCase()}
                />
              </div>
              <div className="input-item-with-label" style={{ width: "100%", margin: "10px 0px" }}>
                <label
                  htmlFor="place"
                  className="form-dropdown-label"
                  style={{ width: "100px" }}
                >
                  {t('place').toUpperCase()}
                </label>
                <div style={{ display: "flex", flexDirection: "column", width: "350px", gap: "5px" }}>
                  <div style={{ display: "flex", flex: "1", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                    <span className='sub-title'>{unitPlaceName || t('notSelected').toUpperCase()}</span>
                    {["superadmin"].includes(currentUser.user_type_xx) &&
                      <CircularButton
                        currentTheme={currentTheme}
                        onClick={(e) => setPlacesDialogOpen(true)}
                        color="#3F51B5"
                        icon={<IoLocationSharp />}
                        width={"30px"}
                        height={"30px"} />}
                  </div>
                  <div className='google-place-wrapper' onClick={() => {
                    if (unitLatitude && unitLongitude && unitPlaceName) { handleOpenMap(unitLatitude, unitLongitude) }
                  }}>
                    <span className='sub-title'>{`${t('latitude')} ${unitLatitude || ""}`}</span>
                    <span className='sub-title'>{`${t('longitude')} ${unitLongitude || ""}`}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton
                iconPosition="end"
                currentTheme={currentTheme}
                borderRadiusType="both"
                variant="tint"
                color="#2563EB"
                onClick={handleBizUnitAction}>
                {`${currencyAction === "addUnit" ? `${t('add')} ${unitName}` : `${t('update')} ${unitName}`}`}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}
      {/* end of adding organization unit */}
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <span className='main-title'>{isProcessingTitle || t('pleaseWait')}</span>
            <ScaleLoader
              color="var(--primary)"
              height={50}
              radius={8}
              width={4}
            />
          </div>
        </motion.div>
      )}

      {placesDialogOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('place')}</h1>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => setPlacesDialogOpen(false)}
                icon={<MdClose />}
                width={"35px"}
                height={"35px"} />
            </div>
            <div className="overlay-content">
              <GooglePlacesSelect onPlaceSelect={handlePlaceSelect} />
              {selectedPlace && (
                <div style={{ display: "flex", flexDirection: "column", gap: "5px", marginTop: "10px" }}>
                  <hr className='separator-h' />
                  <span className='sub-title'>{`${t('place')} : ${selectedPlace.label}`}</span>
                  <span className='sub-title'>{`${t('latitude')} : ${selectedPlace.coordinates.lat}`}</span>
                  <span className='sub-title'>{`${t('longitude')} : ${selectedPlace.coordinates.lng}`}</span>
                </div>
              )}
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton
                currentTheme={currentTheme}
                borderRadiusType="both"
                variant="tint"
                color="#1976D2"
                tooltip={`${t('select')} ${selectedPlace?.label}`}
                iconPosition="start"
                startIcon={<RiMapPin5Fill />}
                onClick={() => {
                  try {
                    setUnitLatitude(selectedPlace?.coordinates.lat);
                    setUnitLongitude(selectedPlace?.coordinates.lng);
                    setUnitPlaceName(selectedPlace?.label);
                    setPlacesDialogOpen(false);
                  } catch (error) {
                    console.log(error);
                  }
                }}
                disabled={!selectedPlace}
              >
                {t('select').toUpperCase()}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}
      {/* progress dialog for file upload  */}
      <UploadDialog
        open={isUploadDialogOpen}
        handleClose={() => setIsUploadDialogOpen(false)}
        uploadProgress={uploadProgress}
      />
    </div>
  );
};


export default AdCompany;
